import styled from 'styled-components'

import Button from 'hsds/components/button'

export const NotyButtonUI = styled(Button)`
  font-family: var(--hsds-global-font-family);
`
